import React from 'react'


function ContractPreviewPDF(props: any) {

    const base64 = props.binary;

    return (
        <div>
            <div className='viewer'>
                
                    <div style={{ height: '750px', width: '100%' }}>
                        <iframe
                            src={`data:application/pdf;base64,${base64}`}
                            width="100%"
                            height="100%"
                        />
                    </div>
                
            </div>
        </div>
    );
}

export default ContractPreviewPDF;